module.exports = {
  colorsData: () => {
    return {
      "IONIQ 5 EV-POWER": {
        "ORO LUNAR":{
          "name":"Oro Lunar",
          "Image": require('./../UI/colors/IONIQ5_PREMIUM/OroLunar.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0xEBE9E2,
            "domeColor": 0xEBE9E2,
            "emissive": 0x000000,

            "metalness": 0.7,
            "roughness": 0.4,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 1.8
          }
        },
        "AZUL ELECTRICO":{
          "name":"Azul Eléctrico",
          "Image": require('./../UI/colors/IONIQ5_PREMIUM/AzulElectrico.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0x7D919E,
            "emissive": 0x000000,
            "domeColor": 0x7D919E,

            "metalness": 0.8,
            "roughness": 0.4,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 2.5,
          }
        },
        "NEGRO ABISMO PERLADO":{
          "name":"Negro Abismo Perlado",
          "Image": require('./../UI/colors/IONIQ5_PREMIUM/NegroAbismoPerlado.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0x2F2F2F,
            "emissive": 0x000000,
            "domeColor": 0x777777,

            "metalness": 1,
            "roughness": 1,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 3,
          }
        },
        "CIBER GRIS METALIZADO":{
          "name":"Ciber Gris Metalizado",
          "Image": require('./../UI/colors/IONIQ5_PREMIUM/CiberGrisMetalizado.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0xBDBDBD,
            "emissive": 0x000000,
            "domeColor": 0xA1A1A1,

            "metalness": 0.4,
            "roughness": 0.4,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 2.0,
          }
        },
        "GRIS ECO PERLADO":{
          "name":"Gris Eco Perlado",
          "Image": require('./../UI/colors/IONIQ5_PREMIUM/GrisEcoPerlado.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0x595E60,
            "emissive": 0x000000,
            "domeColor": 0x5E6061,

            "metalness": 0.4,
            "roughness": 0.4,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 2.2,
          }
        },
        "BLANCO ATLAS":{
          "name":"Blanco Atlas",
          "Image": require('./../UI/colors/IONIQ5_PREMIUM/BlancoAtlas.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0xDFDFDF,
            "emissive": 0x000000,
            "domeColor": 0xD5D5D5,

            "metalness": 0.15,
            "roughness": 0.7,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 1.8,
          }
        },
        "GRIS LUMINOSO MATTE":{
          "name":"Gris Luminoso Matte",
          "Image": require('./../UI/colors/IONIQ5_PREMIUM/GirsLuminosoMate.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0x999EA4,
            "emissive": 0x000000,
            "domeColor": 0x858A8F,

            "metalness": 1,
            "roughness": 0.3,
            "clearCoatIntensity": 0,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 2.5,
          }
        },
      },

    

      "TUCSON HEV LIMITED": {
        "BlancoSereno":{
          "name":"Blanco sereno",
          "Image": require('./../UI/colors/TUCSON_LIMITED/blanco-sereno.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0xF7F7F7,
            "domeColor": 0xE7E7E7,
            "emissive": 0x000000,

            "metalness": 0.2,
            "roughness": 0.7,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0.00,
            "reflectivity": 1,
            "envMapIntensity": 1.5,
          }
        },
        "PlataDiamante":{
          "name":"Plata diamante",
          "Image": require('./../UI/colors/TUCSON_LIMITED/plata-diamante.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0xD2D6D6,
            "domeColor": 0xD4D4D4,
            "emissive": 0x000000,

            "metalness": 1.0,
            "roughness": 0.5,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 2.7,
          }
        },
        "GrisAstral":{
          "name":"Gris Astral",
          "Image": require('./../UI/colors/TUCSON_LIMITED/gris-astral.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0x5F6664,
            "domeColor": 0x5F6967,
            "emissive": 0x000000,

            "metalness": 1.0,
            "roughness": 0.5,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 2.7,
          }
        },
        "AzulOceanico":{
          "name":"Azul oceánico",
          "Image": require('./../UI/colors/TUCSON_LIMITED/azul-oceanico.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0x6F828F,
            "emissive": 0x000000,

            "metalness": 1,
            "roughness": 0.45,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 1.5,
          }
        },
        "GrisEcoPerlado":{
          "name":"Gris eco perlado",
          "Image": require('./../UI/colors/TUCSON_LIMITED/gris-eco-perlado.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0xB2B8B7,
            "emissive": 0x000000,
            "domeColor": 0xA5A8A6,

            "metalness": 1,
            "roughness": 0.325,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 1.75,
          }
        },

        // "BlancoAtlas":{
        //   "name":"Blanco atlas",
        //   "Image": require('./../UI/colors/TUCSON_LIMITED/blanco-atlas.webp'),
        //   "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
        //   "setUp": {
        //     "color": 0xF2F2F2,
        //     "domeColor": 0xEBEBEB,
        //     "emissive": 0x000000,

        //     "metalness": 0.3,
        //     "roughness": 1.1,
        //     "clearCoatIntensity": 1,
        //     "clearCoatRoughness": 0.00,
        //     "reflectivity": 1,
        //     "envMapIntensity": 1.5,
        //   }
        // },
        // "NaranjaJupiter":{
        //   "name":"Naranja Júpiter",
        //   "Image": require('./../UI/colors/TUCSON_LIMITED/naranja-jupiter.webp'),
        //   "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
        //   "setUp": {
        //     "color": 0xE67F5C,
        //     "emissive": 0x000000,
        //     "domeColor": 0xC49887,

        //     "metalness": 0.5,
        //     "roughness": 0.325,
        //     "clearCoatIntensity": 1,
        //     "clearCoatRoughness": 0,
        //     "reflectivity": 1,
        //     "envMapIntensity": 1.75,
        //   }
        // },
        // "NegroAbismoPerlado":{
        //   "name":"Negro abismo perlado",
        //   "Image": require('./../UI/colors/TUCSON_LIMITED/negro-abismo-perlado.webp'),
        //   "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
        //   "setUp": {
        //     "color": 0x302F2F,
        //     "domeColor": 0x777777,
        //     "emissive": 0x000000,

        //     "metalness": 1,
        //     "roughness": 1,
        //     "clearCoatIntensity": 1,
        //     "clearCoatRoughness": 0,
        //     "reflectivity": 1,
        //     "envMapIntensity": 4.25,
        //   }
        // },
        // "RojoDefinitivo":{
        //   "name":"Rojo definitivo",
        //   "Image": require('./../UI/colors/TUCSON_LIMITED/rojo-definitivo.webp'),
        //   "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
        //   "setUp": {
        //     "color": 0x900000,
        //     "domeColor": 0xCB4949,
        //     "emissive": 0x000000,

        //     "metalness": 0.6,
        //     "roughness": 0.385,
        //     "clearCoatIntensity": 1,
        //     "clearCoatRoughness": 0,
        //     "reflectivity": 1,
        //     "envMapIntensity": 2.7,
        //   }
        // },
        // "RojoDinamo":{
        //   "name":"Rojo dinamo",
        //   "Image": require('./../UI/colors/TUCSON_LIMITED/rojo-dinamo.webp'),
        //   "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
        //   "setUp": {
        //     "color": 0xB80606,
        //     "domeColor": 0xEB8383,
        //     "emissive": 0x000000,

        //     "metalness": 0.6,
        //     "roughness": 0.385,
        //     "clearCoatIntensity": 1,
        //     "clearCoatRoughness": 0,
        //     "reflectivity": 1,
        //     "envMapIntensity": 2.7,
        //   }
        // },
        // "VerdeCipres":{
        //   "name":"Verde ciprés",
        //   "Image": require('./../UI/colors/TUCSON_LIMITED/verde-cipres.webp'),
        //   "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
        //   "setUp": {
        //     "color": 0x42544D,
        //     "domeColor": 0x608060,
        //     "emissive": 0x000000,

        //     "metalness": 0.7,
        //     "roughness": 0.5,
        //     "clearCoatIntensity": 1,
        //     "clearCoatRoughness": 0,
        //     "reflectivity": 1,
        //     "envMapIntensity": 2.7,
        //   }
        // },

      },

      "PALISADE SPORT": {
        "GRIS GRAFITO METALIZADO":{
          "name":"Gris Grafito Metalizado",
          "Image": require('./../UI/colors/PALISADE_SPORT/GrisGrafitoMetalizado.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0x999895,
            "domeColor": 0x999895,
            "emissive": 0x000000,

            "metalness": 0.9,
            "roughness": 0.3,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 1.8
          }
        },
        "NEGRO ABISMO PERLADO":{
          "name":"Negro Abismo Perlado",
          "Image": require('./../UI/colors/PALISADE_SPORT/NegroAbismoPerlado.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0x2F2F2F,
            "emissive": 0x000000,
            "domeColor": 0x777777,

            "metalness": 1,
            "roughness": 1,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 3,
          }
        },
        "AZUL ZAFIRO":{
          "name":"Azul Zafiro",
          "Image": require('./../UI/colors/PALISADE_SPORT/AzulZafiro.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0x354865,
            "emissive": 0x000000,
            "domeColor": 0x5372A0,

            "metalness": 0.8,
            "roughness": 0.4,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 2.5,
          }
        },
        "PLATA DIAMANTE":{
          "name":"Plata Diamante",
          "Image": require('./../UI/colors/PALISADE_SPORT/PlataDiamante.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0xBBBBB9,
            "emissive": 0x000000,
            "domeColor": 0xBBBBB9,

            "metalness": 0.8,
            "roughness": 0.4,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 2.0,
          }
        },
        "BLANCO CREMA PERLADO":{
          "name":"Blanco Crema Perlado",
          "Image": require('./../UI/colors/PALISADE_SPORT/BlancoCremaPerlado.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0xC6C6C6,
            "emissive": 0x000000,
            "domeColor": 0xC6C6C6,

            "metalness": 0.025,
            "roughness": 0.95,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 2.2,
          }
        },
      },
      "STARIA LUJO": {
        "NEGRO ABISMO PERLADO":{
          "name":"Negro Abismo Perlado",
          "Image": require('./../UI/colors/STARIA_PREMIUM/NegroAbismoPerlado.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0x2F2F2F,
            "emissive": 0x000000,
            "domeColor": 0x777777,

            "metalness": 1,
            "roughness": 1,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 3,
          }
        },

        "PLATA DIAMANTE":{
          "name":"Plata Diamante",
          "Image": require('./../UI/colors/STARIA_PREMIUM/PlataDiamante.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0xEAEAEA,
            "emissive": 0x000000,
            "domeColor": 0xEAEAEA,

            "metalness": 1,
            "roughness": 0.45,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 1.5,
          }
        },
        "GRIS OLIVA METALICO":{
          "name":"Gris Oliva Metálico",
          "Image": require('./../UI/colors/STARIA_PREMIUM/GrisOlivaMetalico.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0x929490,
            "emissive": 0x000000,
            "domeColor": 0x929490,

            "metalness": 0.8,
            "roughness": 0.4,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 2.5,
          }
        },
        "GRIS GRAFITO METALIZADO":{
          "name":"Gris Grafito Metalizado",
          "Image": require('./../UI/colors/PALISADE_SPORT/GrisGrafitoMetalizado.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0x999895,
            "domeColor": 0x999895,
            "emissive": 0x000000,

            "metalness": 0.9,
            "roughness": 0.3,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 1.8
          }
        },
        "AZUL ZAFIRO":{
          "name":"Azul Zafiro",
          "Image": require('./../UI/colors/STARIA_PREMIUM/AzulZafiro.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0x28364D,
            "emissive": 0x000000,
            "domeColor": 0x456E99,

            "metalness": 0.8,
            "roughness": 0.3,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 2.0,
          }
        },

      },


      "VENUE LIMITED AT": {
        // "AZUL INTENSO T":{
        //   "name":"Azul Intenso T",
        //   "Image": require('./../UI/colors/VENUE_LIMITED_AT/AzulIntenso.webp'),
        //   "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
        //   "setUp": {
        //     "color": 0x2047D5,
        //     "emissive": 0x000000,
        //     "domeColor": 0x4461CF,

        //     "metalness": 0.8,
        //     "roughness": 0.4,
        //     "clearCoatIntensity": 1,
        //     "clearCoatRoughness": 0,
        //     "reflectivity": 1,
        //     "envMapIntensity": 2.5,
        //   }
        // },
        "GRIS ECO":{
          "name":"Gris Eco",
          "Image": require('./../UI/colors/VENUE_LIMITED_AT/GrisEco.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0xCFCFCF,
            "domeColor": 0xD3D3D3,
            "emissive": 0x000000,

            "metalness": 1,
            "roughness": 0.375,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 1.5,
          }
        },
        // "ROJO T":{
        //   "name":"Rojo T",
        //   "Image": require('./../UI/colors/VENUE_LIMITED_AT/RojoT.webp'),
        //   "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
        //   "setUp": {
        //     "color": 0xA80000,
        //     "domeColor": 0xCB4949,
        //     "emissive": 0x000000,

        //     "metalness": 0.8,
        //     "roughness": 0.385,
        //     "clearCoatIntensity": 1,
        //     "clearCoatRoughness": 0,
        //     "reflectivity": 1,
        //     "envMapIntensity": 2.7,
        //   }
        // },
        "PLATA CROMO":{
          "name":"Plata Diamante",
          "Image": require('./../UI/colors/VENUE_LIMITED_AT/PlataCromado.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0xEAEAEA,
            "emissive": 0x000000,
            "domeColor": 0xBFBFBF,

            "metalness": 1,
            "roughness": 0.35,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 1.5,
          }
        },
        "BLANCO T":{
          "name":"Blanco Atlas",
          "Image": require('./../UI/colors/VENUE_LIMITED_AT/BlancoT.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0xD7D7D7,
            "emissive": 0x000000,
            "domeColor": 0xD5D5D5,

            "metalness": 0.025,
            "roughness": 0.95,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 1.9,
          }
        },
      },

      "HB20 ADVANCE": {

        "AZUL ZAFIRO":{
          "name":"Azul Zafiro",
          "Image": require('./../UI/colors/HB20/Azul_safiro.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0x007696,
            "emissive": 0x000000,
            "domeColor": 0x009DB9,

            "metalness": 1,
            "roughness": 0.325,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 2.5,
          }
        },
        "ROJO DRAGON":{
          "name":"Rojo Dragón",
          "Image": require('./../UI/colors/HB20/Rojo_dragon.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0xA80000,
            "domeColor": 0xCB4949,
            "emissive": 0x000000,

            "metalness": 0.8,
            "roughness": 0.385,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 2.7,
          }
        },
        "BLANCO ATLAS":{
          "name":"Blanco Atlas",
          "Image": require('./../UI/colors/HB20/Blanco_atlas.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0xDFDFDF,
            "emissive": 0x000000,
            "domeColor": 0xD5D5D5,

            "metalness": 0.15,
            "roughness": 0.7,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 1.8,
          }
        },
        "PLATA DIAMANTE":{
          "name":"Plata Diamante",
          "Image": require('./../UI/colors/HB20/Plata_diamante.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0xBBBBB9,
            "emissive": 0x000000,
            "domeColor": 0xBBBBB9,

            "metalness": 0.8,
            "roughness": 0.4,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 2.0,
          }
        },
        "Negro Solido":{
          "name":"Negro Sólido",
          "Image": require('./../UI/colors/HB20/Negro_solido.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0x2F2F2F,
            "domeColor": 0x777777,
            "emissive": 0x000000,

            "metalness": 1,
            "roughness": 1,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 4.25,
          }
        },
        "GRIS METALIZADO":{
          "name":"Gris Metalizado",
          "Image": require('./../UI/colors/HB20/Gris_metalizado.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0x999895,
            "domeColor": 0x999895,
            "emissive": 0x000000,

            "metalness": 0.9,
            "roughness": 0.3,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 1.8
          }
        },
      },

      "HB20S ADVANCE": {

        "PLATA DIAMANTE":{
          "name":"Plata Diamante",
          "Image": require('./../UI/colors/HB20S/Plata_diamante.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0xBBBBB9,
            "emissive": 0x000000,
            "domeColor": 0xBBBBB9,

            "metalness": 0.8,
            "roughness": 0.4,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 2.0,
          }
        },
 
        "AZUL ZAFIRO":{
          "name":"Azul Zafiro",
          "Image": require('./../UI/colors/HB20S/Azul_safiro.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0x007696,
            "emissive": 0x000000,
            "domeColor": 0x009DB9,

            "metalness": 1,
            "roughness": 0.325,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 2.5,
          }
        },
        "ROJO DRAGON":{
          "name":"Rojo Dragón",
          "Image": require('./../UI/colors/HB20S/Rojo_dragon.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0xA80000,
            "domeColor": 0xCB4949,
            "emissive": 0x000000,

            "metalness": 0.8,
            "roughness": 0.385,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 2.7,
          }
        },
        "BLANCO ATLAS":{
          "name":"Blanco Atlas",
          "Image": require('./../UI/colors/HB20S/Blanco_atlas.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0xDFDFDF,
            "emissive": 0x000000,
            "domeColor": 0xD5D5D5,

            "metalness": 0.15,
            "roughness": 0.7,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 1.8,
          }
        },

        "NegroSolido":{
          "name":"Negro Sólido",
          "Image": require('./../UI/colors/HB20S/Negro_solido.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0x2F2F2F,
            "domeColor": 0x777777,
            "emissive": 0x000000,

            "metalness": 1,
            "roughness": 1,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 4.25,
          }
        },
        "GRIS METALIZADO":{
          "name":"Gris Metalizado",
          "Image": require('./../UI/colors/HB20S/Gris_metalizado.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0x999895,
            "domeColor": 0x999895,
            "emissive": 0x000000,

            "metalness": 0.9,
            "roughness": 0.3,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 1.8
          }
        },
      },


      "CRETA PREMIUM": {
        "BLANCO ATLAS":{
          "name":"Blanco Atlas",
          "Image": require('./../UI/colors/CRETA_PREMIUM/Atlas_White.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0xD7D7D7,
            "emissive": 0x000000,
            "domeColor": 0xD5D5D5,

            "metalness": 0.025,
            "roughness": 0.95,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 1.9,
          }
        },

        "PLATA":{
          "name":"Plata",
          "Image": require('./../UI/colors/CRETA_PREMIUM/Brisk_Silver.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0xEAEAEA,
            "domeColor": 0xBFBFBF,
            "emissive": 0x000000,

            "metalness": 1,
            "roughness": 0.375,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 1.5,
          }
        },
        "GRIS":{
          "name":"Gris",
          "Image": require('./../UI/colors/CRETA_PREMIUM/Silk_Gray.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0xCFCFCF,
            "emissive": 0x000000,
            "domeColor": 0xD3D3D3,

            "metalness": 1,
            "roughness": 0.35,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 1.5,
          }
        },
      },
      "KONA HEV LIMITED": {
        "AzulDenim":{
          "name":"Azul Denim",
          "Image": require('./../UI/colors/KONA_HIBRIDA/AzulDenim.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0x707F90,
            "emissive": 0x000000,
            "domeColor": 0x647693,

            "metalness": 1,
            "roughness": 0.35,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 1.9,
          }
        },
        "RojoElectricoMetalico":{
          "name":"Rojo Eléctrico Metálico",
          "Image": require('./../UI/colors/KONA_HIBRIDA/RojoElectrico.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0xB53434,
            "domeColor": 0x9C0C0C,
            "emissive": 0x000000,

            "metalness": 1,
            "roughness": 0.45,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0.00,
            "reflectivity": 1,
            "envMapIntensity": 2.1,
          }
        },
        // "AmarilloNeón":{
        //   "name":"Amarillo Neón",
        //   "Image": require('./../UI/colors/KONA_HIBRIDA/AmarilloNeon.webp'),
        //   "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
        //   "setUp": {
        //     "color": 0xDEE23E,
        //     "domeColor": 0xB7C21F,
        //     "emissive": 0x000000,

        //     "metalness": 0.6,
        //     "roughness": 0.385,
        //     "clearCoatIntensity": 1,
        //     "clearCoatRoughness": 0,
        //     "reflectivity": 1,
        //     "envMapIntensity": 2.1,
        //   }
        // },
        // "NegroAbismoPerlado":{
        //   "name":"Negro Abismo Perlado",
        //   "Image": require('./../UI/colors/KONA_HIBRIDA/NegroAbismo.webp'),
        //   "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
        //   "setUp": {
        //     "color": 0x2F2F2F,
        //     "domeColor": 0x777777,
        //     "emissive": 0x000000,

        //     "metalness": 1,
        //     "roughness": 1,
        //     "clearCoatIntensity": 1,
        //     "clearCoatRoughness": 0,
        //     "reflectivity": 1,
        //     "envMapIntensity": 4.25,
        //   }
        // },
        "CiberGrisMetalizado":{
          "name":"Ciber Gris Metalizado",
          "Image": require('./../UI/colors/KONA_HIBRIDA/CiberGris.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0xDDDDDD,
            "domeColor": 0xB5B5B5,
            "emissive": 0x000000,

            "metalness": 1,
            "roughness": 0.75,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 2.1,
          }
        },
        "GrisEcoPerlado":{
          "name":"Gris Eco Perlado",
          "Image": require('./../UI/colors/KONA_HIBRIDA/GrisEcoPerlado.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0xB7B7B7,
            "emissive": 0x000000,
            "domeColor": 0xA5A8A6,

            "metalness": 1,
            "roughness": 0.4,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 1.9,
          }
        },
        "VerdeMiraje":{
          "name":"Verde Miraje",
            "Image": require('./../UI/colors/KONA_HIBRIDA/VerdeMiraje.webp'),
            "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
            "setUp": {
              "color": 0xB7C7BB,
              "domeColor": 0xAFC1AC,
              "emissive": 0x000000,
  
              "metalness": 1,
              "roughness": 0.65,
              "clearCoatIntensity": 1,
              "clearCoatRoughness": 0,
              "reflectivity": 1,
              "envMapIntensity": 2.2,
            }
          },
        "BlancoAtlas":{
          "name":"Blanco Atlas",
          "Image": require('./../UI/colors/KONA_HIBRIDA/BlancoAtlas.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0xF7F7F7,
            "domeColor": 0xF7F7F7,
            "emissive": 0x000000,

            "metalness": 0.2,
            "roughness": 0.7,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0.00,
            "reflectivity": 1,
            "envMapIntensity": 1.5,
          }
        },
      },

      "SANTA FE HEV LIMITED 4x4": {
        "BronceTerrenal":{
          "name":"Bronce Terrenal",
          "Image": require('./../UI/colors/SANTAFE_LIMITED/BronceTerrenal.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0x826f68,
            "domeColor": 0xa68883,
            "emissive": 0x000000,

            "metalness": 1,
            "roughness": 0.35,
            "clearCoatIntensity": 0.35,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 4.25,
          }
        },
        
        "AzulCobalto":{
          "name":"Azul Cobalto",
          "Image": require('./../UI/colors/SANTAFE_LIMITED/AzulCobalto.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0x8b96a5,
            "domeColor": 0x657283,
            "emissive": 0x000000,

            "metalness": 1,
            "roughness": 0.325,
            "clearCoatIntensity": 0.9,
            "clearCoatRoughness": 0.00,
            "reflectivity": 1,
            "envMapIntensity": 2.1,
          }
        },
        "BlancoCrema":{
          "name":"Blanco Crema",
          "Image": require('./../UI/colors/SANTAFE_LIMITED/BlancoCrema.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0xf5f5f5,
            "domeColor": 0xffffff,
            "emissive": 0x000000,

            "metalness": 0.4,
            "roughness": 0.8,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 2.1,
          }
        },

        "GrisMagnetico":{
          "name":"Gris Magnético",
          "Image": require('./../UI/colors/SANTAFE_LIMITED/GrisMagnetico.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0xbec1c0,
            "domeColor": 0xeaeaea,
            "emissive": 0x000000,

            "metalness": 1,
            "roughness": 0.35,
            "clearCoatIntensity": 0.85,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 2.1,
          }
        },
        "NegroAbismoPerlado":{
          "name":"Negro Abismo Perlado",
          "Image": require('./../UI/colors/SANTAFE_LIMITED/NegroAbismoPerlado.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0x191919,
            "emissive": 0x000000,
            "domeColor": 0x777777,

            "metalness": 1,
            "roughness": 0.4,
            "clearCoatIntensity": 1,
            "clearCoatRoughness": 0,
            "reflectivity": 1,
            "envMapIntensity": 1.9,
          }
        },
        "PlataCibernetico":{
          "name":"Plata Cibernético",
            "Image": require('./../UI/colors/SANTAFE_LIMITED/PlataCibernetico.webp'),
            "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
            "setUp": {
              "color": 0xced0ce,
              "domeColor": 0xcdcecb,
              "emissive": 0x000000,
  
              "metalness": 1,
              "roughness": 0.45,
              "clearCoatIntensity": 1,
              "clearCoatRoughness": 0,
              "reflectivity": 1,
              "envMapIntensity": 2.2,
            }
          },
        "PlataCiclonMetalizado":{
          "name":"Plata Ciclón Metalizado",
          "Image": require('./../UI/colors/SANTAFE_LIMITED/PlataCiclonMetalizado.webp'),
          "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
          "setUp": {
            "color": 0x9d9fa3,
            "domeColor": 0x696d74,
            "emissive": 0x000000,

            "metalness": 1,
            "roughness": 0.35,
            "clearCoatIntensity": 0.95,
            "clearCoatRoughness": 0.00,
            "reflectivity": 1,
            "envMapIntensity": 1.5,
          }
        },
        "VerdeOlivo":{
          "name":"Verde Olivo",
            "Image": require('./../UI/colors/SANTAFE_LIMITED/VerdeOlivo.webp'),
            "usdz": "./models/IONIQ_5_PREMIUM/ar-ios/model-orolunar.usdz",
            "setUp": {
              "color": 0x9d9f66,
              "emissive": 0x000000,
              "domeColor": 0x8f9f60,
  
              "metalness": 1,
              "roughness": 0.35,
              "clearCoatIntensity": 1,
              "clearCoatRoughness": 0,
              "reflectivity": 1,
              "envMapIntensity": 1.9,
            }
          },
      },

    }
  }
}